import { NgModule } from "@angular/core";
import { ProjectRegisterVisualizationModule } from "./project/project-register-visualization.module";

@NgModule({
  imports: [
    ProjectRegisterVisualizationModule
  ]
})
export class ProjectsRepositoryRegisterVisualizationModule {}